import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Alert, FormControl, FormGroup, InputGroup, Modal, Button } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import Select from 'react-select';
import { toastr } from 'react-redux-toastr'

import { share_permission_with_emails } from "../../views/Designs/actions";
import CopyLinkContainer from '../../components/CopyLinkContainer';
import Switcher from '../../components/Switcher';
import { Fetch } from '../../utils';

const { feline_fetch } = Fetch;

const ShareLinkModal = ({ template_id, custom_url }) => {
    try {
        const [ copied, set_copied ] = useState(false); 
        const [ share_link, set_share_link ] = useState(null);

        useEffect(() => {
            if (template_id) {
                set_copied(false);
                set_share_link(global.config.website_url + 'designmaker/start/template/' + (custom_url||template_id));
                
            }
        }, [ template_id ]);

        return (
            <>
                <FormGroup>
                    <InputGroup>
                        <FormControl type="text" value={share_link}/>
                        <InputGroup.Addon>
                            <CopyToClipboard 
                                text={share_link}
                                onCopy={() => set_copied(true)}
                            >
                                <span style={{ cursor: 'pointer' }} className="fa fa-copy" />
                            </CopyToClipboard>
                        </InputGroup.Addon>
                    </InputGroup>
                </FormGroup>
                {copied ? (
                    <Alert bsStyle="success" className="text-center">
                        <span className="fa fa-2x fa-check"/> <br /><strong>Link copied to clipboard</strong>
                    </Alert>
                ): ''}
            </>
        )
    } catch (err) {
        console.log('error in LinkShareModal -->>', err);
        return '';
    }
}


const DesignShareModal = ({ design_id, hide_share_modal }) => {
    try {
        const user_options = []
        const share_options = [{ value: 'view', label: 'Can View' }, { value: 'edit', label: 'Can Edit' }];
        const share_link_options = [{value: 'none', label: 'Only shared emails can access this design'}, {value: 'view', label: 'Anyone with link can view'}, {value: 'edit', label: 'Anyone with link can edit'}];

        const Dummy_Dropper = () => (<></>)

        const [ last_email, set_last_email ] = useState('');
        const [ share_emails, set_share_emails ] = useState([]);
        const [ share_role, set_share_role ] = useState('view');
        const [ link_sharing_enabled, set_link_sharing_enabled ] = useState(false);
        const [ enable_share_switch_for_view, set_enable_share_switch_for_view ] = useState(false);
        const [ enable_share_switch_for_edit, set_enable_share_switch_for_edit ] = useState(false);

        const user = useSelector(state => state.user);
        const dispatch = useDispatch();

        const handle_share_emails = emails => { 
            set_share_emails(emails);
            set_last_email('');
        }

        const autocompleteRenderInput = ({ addTag, ...props }) => {
            const handleOnChange = (e, {newValue, method}) => {
                if (method === 'enter') {
                  e.preventDefault()
                } else {
                  props.onChange(e)
                }
            }

            const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
            const inputLength = inputValue.length

            let suggestions = user_options.filter((user) => {
                return user.name.toLowerCase().slice(0, inputLength) === inputValue
            })

            return (
                <Autosuggest
                  ref={props.ref}
                  suggestions={suggestions}
                  shouldRenderSuggestions={(value) => value && value.trim().length > 0}
                  getSuggestionValue={(suggestion) => suggestion.name}
                  renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
                  inputProps={{...props, onChange: handleOnChange}}
                  onSuggestionSelected={(e, {suggestion}) => {
                    addTag(suggestion.name)
                  }}
                  onSuggestionsClearRequested={() => {}}
                  onSuggestionsFetchRequested={() => {}}
                />
            )
        }

        const send_invites = async () => {
            try {
                let emails = [ ...share_emails ];
                if(last_email){
                    emails.push(last_email)
                }
                if(design_id && emails.length > 0 && share_role){
                    await dispatch(share_permission_with_emails(user.email,emails,design_id,share_role))
                    toastr.success('design shared successfully!')
                    hide_share_modal();
                }
            } catch(err) {
                console.log(err)
                toastr.error("Unable to share, something went wrong")
            }
        }

        const alter_link_sharing = async () => {
            try {
                let action = null;
                if (link_sharing_enabled) {
                    action = 'disable';
                } else if (enable_share_switch_for_edit || enable_share_switch_for_view) {
                    action = enable_share_switch_for_edit ? 'enable_edit' : 'enable_view'
                } else {
                    toastr.error('Please choose edit or view rights');
                    return;
                }
                set_link_sharing_enabled(action == 'disable' ? false : true );
                var data = await feline_fetch({ url: 'saved_design/alter_link_sharing', body: { design_id, action } });
                fetch_saved_design_data();
                toastr.success('Link Sharing ' + (action == 'disable' ? 'Disabled' : 'Enabled'))    
            } catch(err) {
                console.error(err);
                toastr.error('something went wrong')    
            }
        }

        const fetch_saved_design_data = async () => {
            try {
                var data = await feline_fetch({ url: 'saved_design/get_one/', body: { id: design_id } })
                set_link_sharing_enabled(data.view_all || data.edit_all);
                set_enable_share_switch_for_view(data.view_all);
                set_enable_share_switch_for_edit(data.edit_all);
            } catch(err) {
                console.log("error in fetching data --- >>>> ", err);
            }
        }

        useEffect(() => {
            if (design_id) {
                fetch_saved_design_data();
            }
        }, [ design_id ])

        return (
            <>
                <div>
                    <TagsInput 
                        renderInput={autocompleteRenderInput} 
                        value={share_emails} 
                        inputValue={last_email} 
                        inputProps={{placeholder: "Type one or more emails"}} 
                        onChange={handle_share_emails} 
                        onChangeInput={set_last_email} 
                    />
                    <Select 
                        options={share_options} 
                        defaultValue={share_options[0]} 
                        onChange={e => set_share_role(e.value)}
                    />
                    <Button type="button" onClick={send_invites} className="popover-button-custom" style={{'width': '100%', marginTop: 5}} type="submit">Send Invites</Button>

                </div>
                <hr/>
                <div>
                    {link_sharing_enabled ? (
                        <>
                            <div>Link sharing is enabled for this design. Anyone with the link can <b>{enable_share_switch_for_edit ? 'edit' : 'view'}</b> it.</div>
                            <CopyLinkContainer 
                                link={global.config.website_url + "designmaker/start/designs/" + design_id + "/" + (enable_share_switch_for_edit ? 'edit' : 'view')}
                            />
                        </>
                    ) : (
                        <>
                            <Switcher 
                                title="Anyone with link can edit" 
                                show_dropper={enable_share_switch_for_edit} 
                                trigger_on_click={() => set_enable_share_switch_for_edit(!enable_share_switch_for_edit)} 
                                col_width_title={8} 
                                col_width_switch={4} 
                                Dropper={Dummy_Dropper}
                            />
                            <Switcher 
                                title="Anyone with link can view" 
                                show_dropper={enable_share_switch_for_view} 
                                trigger_on_click={() => set_enable_share_switch_for_view(!enable_share_switch_for_view)} 
                                col_width_title={8} 
                                col_width_switch={4} 
                                Dropper={Dummy_Dropper}
                            />
                        </>
                    )}

                    <Button type="button" onClick={alter_link_sharing} className="popover-button-custom" style={{'width': '100%', marginTop: 5}} type="submit">{link_sharing_enabled ? "Disable Link Sharing" : "Enable Link Sharing"}</Button>
                </div>
            </>
        );
    } catch(err) {
        console.log('error in share design modal -->>>>>> ', err);
        return '';
    }
}


const ShareModal = ({ show_share_modal, hide_share_modal, template_id, custom_url, is_saved_design, design_id }) => {
    try {

        return (
            <Modal show={show_share_modal} onHide={hide_share_modal}>
                <Modal.Header closeButton>
                    <Modal.Title style={{fontFamily: 'Montserrat', fontWeight: 800}}>{is_saved_design ? "Share your design" : "Template share link"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {is_saved_design ? (
                        <DesignShareModal 
                            design_id={design_id} 
                            hide_share_modal={hide_share_modal} 
                        />        
                    ) : (
                        <ShareLinkModal 
                            template_id = {template_id}
                            custom_url = {custom_url}      
                        />        
                    )}
                </Modal.Body>
            </Modal>    
        )
    } catch(err) {
        console.log('error in ShareModal -->>', err);
        return '';
    }
}


export default ShareModal